import "babel-polyfill";
import "./libs/jquery";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/slick";

import {binder} from "./libs/binder";
import {constants, scrollTo, mobileNav, searchToggle, headerTheme} from "./modules/module";
import {customSelect} from "./modules/customSelect";
import {quoteSlider} from "./modules/quote-slider";
import {insightsSlider} from "./modules/insights-slider";
import {orderedSlider} from "./modules/orderedSlider";
import {map} from "./modules/map";
import {processItemsHover} from "./modules/processItemsHover";

binder({
    bounds: {
        "html": [constants],
        ".header": [mobileNav, searchToggle, headerTheme],
        "select": customSelect,
        ".scroll": scrollTo,
        ".quotes .slider": quoteSlider,
        ".map": map,
        ".insights-slider": insightsSlider,
        ".ordered-slider-section": orderedSlider,
        ".process-item": processItemsHover
    }
});



// WEBPACK FOOTER //
// ./assets/js/global.js